<template>
  <div class="post__content custom-scrollbar">
    <span v-if="content !== null && !post.isPrivate" v-dompurify-html:postContent="content" />
    <div class="text-center text-grey-6">
      <em v-if="post.isPrivate">
        {{ clientName }} shared a post created by another user.
        Due to permissions set by the post author,
        we are unable to pull this post into Private Footprint.
        Click <a :href="post.link">here</a>
        to view this post on {{ post.socialSite.name }}
        (if you are connected to {{ clientName }}).
      </em>
      <em v-else-if="!post.content">This post has no text content.</em>
    </div>
  </div>
</template>

<style lang="scss">
.post__content {
  overflow-y: auto;
  .flagged {
    background-color: bisque;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import { StringMatchRule, replaceAll } from '@/util/string';

export default defineComponent({
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
    highlight: {
      type: Array as () => StringMatchRule[],
      default: () => [],
    },
  },
  computed: {
    clientName(): string {
      return this.post.client.firstName;
    },
    content(): string|null {
      if (this.post.content === null || !this.highlight.length) return this.post.content;
      return replaceAll(
        this.highlight,
        this.post.content,
        needle => `<span class="flagged">${needle}</span>`,
      );
    },
  },
});
</script>
